import {WPApi} from "../common/wp-api";
import {isMobileScreen} from "../common/utils";

const wp = new WPApi();

const isMobile = window.outerWidth <= 768;

let analyticsCategory;
let currentActiveTab = 'news';


let currentPage = 1;
jQuery(document).ready(async ($) => {
    // if ($('.tab-link.selected').attr('id') !== 'games') {
    //     await displayContentPosts($('.tab-link.selected').attr('id'));
    // } else {
    //     await displayGames($('.time-games-tab.selected').attr('id'), true);
    // }

    $(document).on('click', '.load-more', async function () {

        currentPage++;
        $(this).css({
            'opacity': 0.5,
            'pointer-events': 'none'
        });
        await displayContentPosts('post', true, {page: currentPage, posts_only: true});
        $(this).css({
            'opacity': 1,
            'pointer-events': 'unset'
        });
    });

    if (isParentCategory()) {
        analyticsCategory = 'branch-page';
    } else {
        analyticsCategory = 'league-page';
    }

    $('.tab-link').click(async function () {
        if (!$(this).hasClass('selected')) {

            $('.tab-link.selected').removeClass('selected');
            $(this).addClass('selected');
            const tabId = $(this).attr('id');
            // Build clean URL path without trailing slash issues
            const basePath = window.location.pathname.replace(/\/(video|games|table|scorers|team|leagues|post)\/?$/, '').replace(/\/$/, '');
            const newUrl = tabId === 'post' ? basePath : basePath + '/' + tabId;
            window.history.pushState('', '', newUrl);
            let divContainer = $('.content-selected');
            divContainer.removeClass(currentActiveTab);
            currentActiveTab = tabId;

            sendEvent('tab-click', tabId);


            if (tabId === 'games') {
                divContainer.hide();
                divContainer.html('');
                $('.games-top-container').addClass('d-block');
                await displayGames($('.time-games-tab.selected').attr('id'), false);
            } else {
                if ($('.games-top-container').hasClass('d-block')) {
                    $('.games-top-container').removeClass('d-block');
                    $('.games-top-container').addClass('d-none');
                }

                await displayContentPosts($(this).attr('id'));
            }
        }
    });

    $('.time-games-tab').click(async function () {
        if (!$(this).hasClass('selected')) {
            $('.time-games-tab.selected').removeClass('selected');
            $(this).addClass('selected');
            // Keep the current path and just add/update the tab_games query param
            const currentPath = window.location.pathname;
            window.history.pushState('', '', currentPath + '?tab_games=' + $(this).attr('id'));

            await displayGames($('.time-games-tab.selected').attr('id'), true);
        }
    })

    $(document).on('click', '.post-card', function () {
        let label = $('h3', this).text().trim();
        sendEvent('news-article-click', label);
    });

    $(document).on('click', '.leagues .teams-card', function () {
        let label = $('.team-name', this).text().trim();
        sendEvent('league-click', label);
    });

    $(document).on('click', '.content-selected .video-card:not(:first-child)', function () {
        let label = $('h3', this).text().trim();
        sendEvent('play', label);
    });

    $(document).on('click', '.content-selected .video-card:first-child', function () {
        sendEvent('game-play', 'main-game');
    });

    $(document).on('click', '.all-videos', function () {
        sendEvent('all-games-click', 'vod');
    });

    $(document).on('click', '.team-info > .data', function () {
        let label = $('.team-name', this).text().trim();
        sendEvent('table-line-click', label);
    });

    $(document).on('click', '.scorers-card', function () {
        let label = $('.scorer-name', this).text().trim();
        sendEvent('king-of-goals-click', label);
    });

    $(document).on('click', '.content-container.team .teams-card', function () {
        let label = $('.team-name', this).text().trim();
        sendEvent('team-click', label);
    });

    $(document).on('click', '.game-card', function () {

        let teams = $('.team-name', this).map(function () {
            return $(this).text().trim();
        }).toArray().join('-');

        sendEvent('game-click', teams);
    });


    function isParentCategory() {
        return $('body').hasClass('category-parent');
    }
});

async function displayContentPosts(id, append = false, args = {}) {
    let divContainer = $('.content-selected');
    // divContainer.addClass(id);

    args.is_mobile = isMobile;

    let urlParams = new URLSearchParams(args);

    let urlRequest = 'sport1/v1/league/' + pageGlobals.object_id + '/' + id + '/content?' + urlParams.toString();
    if (id === 'video') {
        urlRequest = urlRequest + '&rows=10';
    }
    console.log(pageGlobals);
    console.log(urlRequest);
    let response = await wp.get(urlRequest);

    if (!append) {
        divContainer.hide();
        divContainer.html('');
    }

    $('.load-more').remove();

    divContainer.append(response);
    divContainer.fadeIn(200);
    lazyLoader.update();
}

async function displayGames(idTabSelected, hideAndDeleteContent) {
    let divContainer = $('.content-selected');
    // divContainer.addClass(idTabSelected);
    let urlRequest = 'sport1/v1/league/' + pageGlobals.object_id + '/games/' + idTabSelected + '/content';
    let response = await wp.get(urlRequest);
    if (hideAndDeleteContent) {
        divContainer.hide();
        divContainer.html('');
    }
    divContainer.append(response);
    divContainer.fadeIn(200);
    lazyLoader.update();
}

function sendEvent(action, label) {
    let suffix = getAnalyticsCategorySuffixByTab(currentActiveTab);
    let category = `${analyticsCategory}-${suffix}`
    sport1Analytics.sendEvent(category, action, label);
}

function getAnalyticsCategorySuffixByTab(tabId) {

    let suffix;

    switch (tabId) {
        case 'post':
            suffix = 'news';
            break;

        case 'leagues':
            suffix = 'leagues';
            break;

        case 'video':
            suffix = 'vod';
            break;
        case 'games':
            suffix = 'score';
            break;
        case 'table':
            suffix = 'table';
            break;
        case 'scorers':
            suffix = 'king';
            break;
        case 'team':
            suffix = 'teams';
            break;

        default:
            suffix = 'news';
            break;
    }

    return suffix;

}

